import React from "react";
import "./Link.scss";

export const Link = ({ props }) => {
  return (
    <a
      className={`process-filter-link process-filter-link-${props.id}`}
      href={props.linkUri}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.linkTitle}
    </a>
  );
};
